<template>
  <span>
     <input type="checkbox" class="fct-checkbox" :id="_id"
             :disabled='disabled'
             v-model='inputVal' :checked='inputVal'>
     <label v-text='label' :for="_id"></label>
  </span>
</template>

<script>
  import chainableVModel from "../mixins/chainableVModel";

  export default {
    props: ['value', 'label', 'disabled', 'id'],
    mixins: [chainableVModel],
    computed: {
      _id() {
        return this.id || this.label.split(/s+/).join('-').toLowerCase()
      },
    }
  }
</script>

<style scoped>

</style>
